<template>
  <v-card width="100%" color="transparent" class="mx-auto">
    <v-card-text>
      <introduction></introduction>
    </v-card-text>
    <v-card-text>
      <about></about>
    </v-card-text>
    <v-card-text>
      <skills></skills>
    </v-card-text>
    <v-card-text>
      <portfolio></portfolio>
    </v-card-text>
    <v-card-text>
      <contact></contact>
    </v-card-text>
  </v-card>
</template>

<script>
import about from "@/components/about.vue";
import skills from "@/components/skills.vue";
import introduction from "@/components/introduction.vue";
import portfolio from '@/components/portfolio.vue';
import contact from '@/components/contact.vue';

export default {
  name: "Home",

  components: {
    introduction,
    about,
    skills,
    portfolio,
    contact,
  },
};
</script>
